export class CopyTarget {
  attachClickEvents(selector) {
    document.querySelectorAll(selector).forEach((elem) => {
      elem.addEventListener("click", this.copy.bind(this, elem));
    });
  }

  copy(elem) {
    if (!elem.dataset.target) return;

    const textarea = document.createElement("textarea");
    textarea.innerText = `${elem.dataset.target}`;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();

    if (!elem.dataset.noAlert) alert("コピーしました");
  }
}

